<template>
    <img v-show="url.x2" :src="url.x2" :srcset="url.x3 && (url.x3 + ' 3x')">
</template>
<script>
export default {
    name:"yd-image",
    props:{
        src:{
            type:String,
            default:null
        }
    },
    computed:{
        url(){
            var obj = {};
            if(this.src){
                try{
                    let x2 = require('@images/' + this.src + '@2x.png');
                    obj.x2 = x2;
                }catch{
                    obj.x2 = '';
                }
                try{
                    let x3 = require('@images/' + this.src + '@3x.png');
                    obj.x3 = x3;
                }catch{
                    obj.x3 = '';
                }
                if(!obj.x2 && obj.x3){
                    obj.x2 = obj.x3;
                    obj.x3 = '';
                }
            }
            return obj;
        }
    }
}
</script>